export default class ApplicationModel{
    id;
    name;
    destination;
    purpose;
    email;
    surname;
    title;
    birth;
    number;
    dateCreated;
    experience;
    education;
    status;

    constructor(id, name, destination, purpose, email, surname, title, birth, number, dateCreated, experience, education, status) {
        this.id = id;
        this.name = name;
        this.destination = destination;
        this.purpose = purpose;
        this.email = email;
        this.surname = surname;
        this.title = title;
        this.birth = birth;
        this.number = number;
        this.dateCreated = dateCreated;
        this.experience = experience;
        this.education = education;
        this.status=status;
    }

    /**
     *
     * @param {DocumentSnapshot} application
     * @returns {ApplicationModel}
     */
    static fromFirestore(application){
        const data = application.data();
        return new ApplicationModel(
            application.id,
            data.name,
            data.destination,
            data.purpose,
            data.email,
            data.surname,
            data.title,
            data.birth,
            data.number,
            data.dateCreated.toDate(),
            data.experience,
            data.education,
            data.status||'pending'
        )
    }

    /**
     *
     * @param {ApplicationModel} application
     * @returns {ApplicationModel}
     */
    static copy(application){
        return new ApplicationModel(
            application.id,
            application.name,
            application.destination,
            application.purpose,
            application.email,
            application.surname,
            application.title,
            application.birth,
            application.number,
            application.dateCreated,
            application.experience,
            application.education,
            application.status
        )
    }

    toJSON(){
        return {
            name:this.name,
            destination:this.destination,
            purpose:this.purpose,
            email:this.email,
            surname:this.surname,
            title:this.title,
            birth:this.birth,
            number:this.number,
            dateCreated:this.dateCreated,
            experience:this.experience,
            education:this.education,
            status:this.status,
        }
    }
}